import React from 'react'
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic'
import { apartments } from '../../../utils/redux/config/apartments'
import PageLayout from '../../../components/layouts/PageLayout'
import { Link } from 'react-router-dom'
import { getStatusColor, getRoomsText } from '../../../utils/apartments'
import Carousel from '../../../components/Carousel'
import NumberFormat from 'react-number-format'
import Gallery from '../../../components/Gallery'
import { withNamespaces } from 'react-i18next'
import { translate, getLang } from '../../../utils/translate'

class View extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			error: null,
			result: null,
			openImage: false,
			photoIndex: 0
		}
	}
	onClickHandler = () => {
		this.setState({
			openImage: true
		})
	}
	static getDerivedStateFromProps(nextProps, prevState) {

		const { t } = nextProps
		const { entrance, floorNum, appNum } = nextProps.match.params
		// Check if apartment appNum and floorNum are integer and
		// check if there is apartment with such appNum and floorNum
		if (Number.isInteger(parseInt(floorNum, 10)) && Number.isInteger(parseInt(appNum, 10))) {
			const apartment = apartments.find(ap => ap.number === parseInt(appNum, 10) && ap.entranceUrl === entrance && ap.floor === parseInt(floorNum, 10))
			if (apartment) {
				const status = translate(apartment.status)
				const type = translate(apartment.type)
				const position = translate(apartment.position)
				return {
					result: {
						...apartment,
						type,
						position,
						status: getStatusColor(status),
						roomType: getRoomsText(apartment.rooms, getLang())
					}
				}
			} else {
				return {
					error: t('messages.invalidUrl')
				}
			}
		} else {
			return {
				error: t('messages.invalidUrl')
			}
		}
	}

	componentDidMount() {
		const { t } = this.props
		const { entrance, floorNum, appNum } = this.props.match.params
		// Check if apartment appNum and floorNum are integer and
		// check if there is apartment with such appNum and floorNum
		if (Number.isInteger(parseInt(floorNum, 10)) && Number.isInteger(parseInt(appNum, 10))) {
			const apartment = apartments.find(ap => ap.number === parseInt(appNum, 10) && ap.entranceUrl === entrance && ap.floor === parseInt(floorNum, 10))
			if (apartment) {
				const status = translate(apartment.status)
				const type = translate(apartment.type)
				const position = translate(apartment.position)
				this.setState({
					result: {
						...apartment,
						type,
						position,
						status: getStatusColor(status),
						roomType: getRoomsText(apartment.rooms, getLang())
					}
				})
			} else {
				this.setState({
					error: t('messages.invalidUrl')
				})
			}
		} else {
			this.setState({
				error: t('messages.invalidUrl')
			})
		}
	}
	render() {
		const { error, result, openImage, photoIndex } = this.state
		const { t } = this.props
		if (error || !result) {
			return <PageLayout>
				<div className='c-content'>
					<div className='o-wrapper'>
						<p>{error}</p>
					</div>
				</div>
			</PageLayout>
		}


		const { entrance, floorNum, id } = this.props.match.params

		return <PageLayout showBreadcrumbs>
			<BreadcrumbsItem to='/'>{t('general.home')}</BreadcrumbsItem>
			<BreadcrumbsItem to='/apartments'>{t('general.apartment', { count: 2 })}</BreadcrumbsItem>
			<BreadcrumbsItem to={`/apartments/${entrance}/${floorNum}`}>{`${t('general.entrance')} ${result.entrance}, ${t('general.floor_short')} ${result.floor} `}</BreadcrumbsItem>
			<BreadcrumbsItem to={`/apartments/${entrance}/${floorNum}/${id}`}><span className='u-text-capitalize'>{`${result.type} ${result.number}`}</span></BreadcrumbsItem>
			{openImage && <Gallery
				items={result.apartmentPlans}
				photoIndex={photoIndex}
				onCloseRequest={() => this.setState({ openImage: false })}
				onMovePrevRequest={() =>
					this.setState({
						photoIndex: (photoIndex + result.apartmentPlans.length - 1) % result.apartmentPlans.length,
					})
				}
				onMoveNextRequest={() =>
					this.setState({
						photoIndex: (photoIndex + 1) % result.apartmentPlans.length,
					})
				}
			/>
			}
			<div className='c-content'>
				<div className='o-wrapper'>
					{result &&
						<div className='o-layout u-flex u-margin-top-small u-margin-bottom u-margin-top@desktop u-margin-bottom-large@desktop non-printable'>
							<div className='o-layout__item u-flex u-flex--column u-flex--center u-1/1 u-1/2@desktop'>
								<Carousel
									className='c-plans-slider'
									options={{
										slidesToShow: 1
									}}>
									{result.apartmentPlans.map(plan => <img key={plan} className='u-cursor-pointer' src={plan} onClick={this.onClickHandler} alt='Apartment plan' />)}
								</Carousel>
							</div>
							<div className='o-layout__item u-flex u-flex--column u-flex--center u-1/1 u-1/2@desktop u-margin-top u-margin-top-none@desktop '>
								<div className='u-text--large u-text--black u-text-capitalize u-margin-bottom'>{result.type} {result.number}</div>
								<div className='o-layout'>
									<div className='o-layout__item u-1/2 u-text--normal'><span className='o-block o-block--left u-text--large u-text--bud u-weight--bold'>{result.netArea} m<sup>2</sup></span><span className='o-block o-block--left'>{t('general.netArea')}</span></div>
									<div className='o-layout__item u-1/2 u-text--normal'><span className='o-block o-block--right u-text--large u-text--bud u-weight--bold'>{result.grossArea} m<sup>2</sup></span><span className='o-block o-block--right'>{t('general.grossArea')}</span></div>
								</div>
								<div className='u-margin-vertical-small u-border-bottom--finch-20'></div>
								<div className='o-layout'>
									<div className='o-layout__item u-1/2 u-text--normal'>{t('general.status')}</div>
									<div className='o-layout__item u-1/2 u-text--normal o-block--right'><span className={`u-text--${result.status.color} u-weight--bold`}>{result.status.label}</span></div>
								</div>
								<div className='u-margin-vertical-small u-border-bottom--finch-20'></div>
								<div className='o-layout'>
									<div className='o-layout__item u-1/2 u-text--normal'>{t('general.entrance')}</div>
									<div className='o-layout__item u-1/2 u-text--normal u-text--bud o-block--right'>{result.entrance}</div>
								</div>
								<div className='u-margin-vertical-small u-border-bottom--finch-20'></div>
								<div className='o-layout'>
									<div className='o-layout__item u-1/2 u-text--normal'>{t('general.floor')}</div>
									<div className='o-layout__item u-1/2 u-text--normal u-text--bud o-block--right'>{result.floor}</div>
								</div>
								<div className='u-margin-vertical-small u-border-bottom--finch-20'></div>
								<div className='o-layout'>
									<div className='o-layout__item u-1/2 u-text--normal'>{t('general.type')}</div>
									<div className='o-layout__item u-1/2 u-text--normal u-text--bud o-block--right'>{result.roomType}</div>
								</div>
								<div className='u-margin-vertical-small u-border-bottom--finch-20'></div>
								<div className='o-layout'>
									<div className='o-layout__item u-1/2 u-text--normal'>{t('apartments.position')}</div>
									<div className='o-layout__item u-1/2 u-text--normal u-text--bud o-block--right'>{result.position}</div>
								</div>
								<div className='u-margin-vertical-small u-border-bottom--finch-20'></div>
								{result.status.color === "apple" && <div className='o-layout'>
									<div className='o-layout__item u-1/1 u-text--normal'><span className='o-block o-block--left u-text--large u-text--bud u-weight--bold'>{t('apartments.priceNegotiable')}</span></div>
								</div>}
								<div className='o-block u-margin-top non-printable'>
									<button className='c-btn c-btn--finch u-margin-right' title={t('general.print')} onClick={() => window.print()}><span className='c-icon--print--white'></span></button>
									<Link to='/apartments' className='c-btn c-btn--finch'>{t('apartments.goToApartments')} &#8594;</Link>
								</div>
							</div>
						</div>
					}
				</div>
				<div className='o-layout printable'>
					<div className='o-layout__item u-1/1'>
						<div className='u-text--large u-text--black u-text-capitalize u-margin-bottom'>{t('general.siteName')} - {result.type} {result.number}</div>
						<div className='group u-margin-bottom'>
							{result.apartmentPlans.map(plan => <div key={plan}><img src={plan} alt='apartment plan' /></div>)}
						</div>
					</div>
					<div className='o-layout__item u-1/1'>
						<div className='o-layout__item u-flex u-flex--column u-flex--center u-1/1'>
							<div className='o-layout'>
								<div className='o-layout__item u-1/2 u-text--normal'><span className='o-block o-block--left u-text--large u-text--bud u-weight--bold'>{result.netArea} m<sup>2</sup></span><span className='o-block o-block--left'>{t('general.netArea')}</span></div>
								<div className='o-layout__item u-1/2 u-text--normal'><span className='o-block o-block--right u-text--large u-text--bud u-weight--bold'>{result.grossArea} m<sup>2</sup></span><span className='o-block o-block--right'>{t('general.grossArea')}</span></div>
							</div>
							<div className='u-margin-vertical-small u-border-bottom--finch-20'></div>
							<div className='o-layout'>
								<div className='o-layout__item u-1/5'>
									<div className='o-layout'>
										<div className='o-layout__item u-1/1 u-text--normal'>{t('general.status')}</div>
										<div className='o-layout__item u-1/1 u-text--normal'><span className={`u-text--${result.status.color} u-weight--bold`}>{result.status.label}</span></div>
									</div>
								</div>
								<div className='o-layout__item u-1/5'>
									<div className='o-layout'>
										<div className='o-layout__item u-1/1 u-text--normal'>{t('general.entrance')}</div>
										<div className='o-layout__item u-1/1 u-text--normal u-text--bud u-weight--bold'>{result.entrance}</div>
									</div>
								</div>
								<div className='o-layout__item u-1/5'>
									<div className='o-layout'>
										<div className='o-layout__item u-1/1 u-text--normal'>{t('general.floor')}</div>
										<div className='o-layout__item u-1/1 u-text--normal u-text--bud u-weight--bold'>{result.floor}</div>
									</div>
								</div>
								<div className='o-layout__item u-1/5'>
									<div className='o-layout'>
										<div className='o-layout__item u-1/1 u-text--normal'>{t('general.type')}</div>
										<div className='o-layout__item u-1/1 u-text--normal u-text--bud u-weight--bold'>{result.roomType}</div>
									</div>
								</div>
								<div className='o-layout__item u-1/5'>
									<div className='o-layout'>
										<div className='o-layout__item u-1/1 u-text--normal'>{t('apartments.position')}</div>
										<div className='o-layout__item u-1/1 u-text--normal u-text--bud u-weight--bold'>{result.position}</div>
									</div>
								</div>
							</div>
							<div className='u-margin-vertical-small u-border-bottom--finch-20'></div>
							{result.status.color === 'apple' && <div className='o-layout'>
								<div className='o-layout__item u-1/1 u-text--normal'><span className='o-block o-block--left u-text--large u-text--bud u-weight--bold'>{t('apartments.priceNegotiable')}</span></div>
							</div>}
						</div>
					</div>
				</div>
			</div>
		</PageLayout>
	}
}

export default withNamespaces()(View)



// WEBPACK FOOTER //
// ./src/routes/SingleApartment/components/View.js